/*
 * Baked with love in the buzzwoo Theme Oven
 * E-Com Kitchen | Fresh from the Oven | https://buzzwoo.de
 * Asset: truncate-toggle.js
 * Purpose: Toggles truncated text wrappers open/closed on click (skips interactive elements)
 * Architecture: Built on Ignite v2.6.1 foundation
 */
document.addEventListener("click", (e) => {
  const wrap = e.target.closest('.truncate-wrap[data-truncated="true"]');
  if (!wrap) return;

  // Nicht toggeln, wenn ein echtes interaktives Element geklickt wird
  if (e.target.closest('a, button, input, textarea, select, label')) return;

  wrap.classList.toggle("is-open");
});
